"use client";

import "@/assets/styles/js/map";

import React, { useRef, useState } from "react";

export default function Map({ data }) {
  const { token, coordinates = [] } = data;
  const accessToken = token;
  const defaultZoom = 13;
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(coordinates[0]);
  const [lat, setLat] = useState(coordinates[1]);
  const [zoom, setZoom] = useState(defaultZoom);
  const [active, setActive] = useState(false);
  const staticMap = `https://api.mapbox.com/styles/v1/mapbox/light-v11/static/${lng},${lat},${defaultZoom},0/1200x600?access_token=${accessToken}`;

  return (
    <div
      className="bg-img h-96 w-full flex items-center justify-center relative"
      style={{ backgroundImage: `url(${staticMap})` }}
    >
      {!active && (
        <button
          className="btn absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          onClick={async () => {
            const { default: mapboxgl } = await import("mapbox-gl");
            mapboxgl.accessToken = accessToken;

            setActive(true);

            const activateMap = () => {
              if (!map.current) {
                console.log("active map");
                map.current = new mapboxgl.Map({
                  container: mapContainer.current,
                  style: "mapbox://styles/mapbox/streets-v12",
                  center: [lng, lat],
                  zoom: zoom,
                });

                map.current.on("move", () => {
                  setLng(map.current.getCenter().lng.toFixed(4));
                  setLat(map.current.getCenter().lat.toFixed(4));
                  setZoom(map.current.getZoom().toFixed(2));
                });

                new mapboxgl.Marker({ color: "#CB3F60" })
                  .setLngLat([lng, lat])
                  .addTo(map.current);
              }
            };

            activateMap();
          }}
        >
          View map
        </button>
      )}
      <div ref={mapContainer} className="map-container h-full w-full" />
    </div>
  );
}
